import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// PWA Service Worker Registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('PWA: Service Worker registered', registration.scope);
      })
      .catch(error => {
        console.log('PWA: Service Worker registration failed', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
